import React, { useEffect, useRef } from 'react';
import L from 'leaflet';
import ZoomButtons from '../../../components/map/ZoomButtons';
import CurrentLocationButton from '../../../components/map/CurrentLocationButton';
import './MapControlStack.css';

const POSITIONS = {
  bottomright: 'map-control-stack--bottomright',
  bottomleft: 'map-control-stack--bottomleft',
  topright: 'map-control-stack--topright',
  topleft: 'map-control-stack--topleft',
};

/**
 * Shared on-map control column: optional extra controls, current location, zoom.
 * Must be rendered inside a react-leaflet MapContainer.
 */
export default function MapControlStack({
  position = 'bottomright',
  showLocation = true,
  showZoom = true,
  className = '',
  style,
  zoomClassName = '',
  zoomButtonClassName = '',
  onZoom,
  children,
}) {
  const ref = useRef(null);

  useEffect(() => {
    if (!ref.current) return;
    L.DomEvent.disableClickPropagation(ref.current);
    L.DomEvent.disableScrollPropagation(ref.current);
  }, []);

  const positionClass = POSITIONS[position] || POSITIONS.bottomright;

  return (
    <div ref={ref} className={`map-control-stack ${positionClass} ${className}`.trim()} style={style}>
      {children}
      {showLocation && <CurrentLocationButton />}
      {showZoom && (
        <ZoomButtons className={zoomClassName} buttonClassName={zoomButtonClassName} onZoom={onZoom} />
      )}
    </div>
  );
}
